import { type GetPlansResponse } from '@bbkAdminRedux/rtkq/optimizations.slice';

export class OptimizationActionsHelper {
  static getPlanIdLabel =
    (plans: GetPlansResponse['collection']) =>
    (planId: string): string => {
      const plan = plans.find((p) => p.id === planId);
      return plan?.id ?? planId;
    };

  static getPlanOptions = (plans: GetPlansResponse['collection']) =>
    plans.map((plan) => ({
      value: plan.id,
      label: plan.id,
      currencyCode: plan.currency_code,
    }));

  static filterPlanOptionsByCurrency = <
    T extends {
      currencyCode: string;
    },
  >(
    options: T[],
    currencyCode?: string
  ) =>
    currencyCode
      ? options.filter((option) => option.currencyCode === currencyCode)
      : options;
}
